export default __webpack_public_path__ + "static/media/bolji_posao.52c98692.png";